import buscarPneusDinamicos from "@/services/vex/buscarPneus";

export async function getTireManufacturers() {
    let pneus = [];
    
    let pneusDinamicos;

    try {
        pneusDinamicos = await buscarPneusDinamicos();
    } catch (error) {
        console.error(error);
    }

    if (pneusDinamicos) {
        let marcas = [];
        pneusDinamicos.forEach((pneus) => {
            if (pneus && pneus.marca) {
                marcas.push(pneus.marca);
            }
        });
        pneus = marcas;
    } else {
        pneus = [
            "Achilles",
            "Apollo",
            "Aptany",
            "Armstrong",
            "Barum",
            "Beeze",
            "BF Goodrich",
            "Boto",
            "Bridgestone",
            "Bridgestone Ecopia",
            "Champiro",
            "Cheng Shaw",
            "Chrono",
            "Compazal",
            "Continental",
            "Cooper CS1",
            "Cordial",
            "Dayton",
            "Delinte",
            "Doublestar",
            "Dunlop",
            "Falken",
            "Fate",
            "Ferentino",
            "Firestone",
            "Fórmula",
            "Fortune",
            "Fullrun",
            "General",
            "General Tire",
            "Giti",
            "Goodyear",
            "Green Max",
            "Hankook",
            "Hifly",
            "Horizon",
            "KAPATOS",
            "Kumho",
            "Levorin",
            "LingLong",
            "MASSIMO",
            "Maxisport",
            "Maxxis",
            "Michelin",
            "Onyx",
            "Pirelli",
            "Royal",
            "Sailun",
            "Semperit",
            "Speed Max",
            "Starfire",
            "Sumitomo",
            "Technic",
            "Tornel",
            "Trazano",
            "Triangle",
            "Vectra",
            "Waterfall",
            "Westlake",
            "Winrun",
            "Xbri",
            "Yokohama",
            "Outra"
        ];
    }

    return pneus;
}
